import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-unified-solutions',
  templateUrl: './unified-solutions.component.html',
  styleUrls: ['./unified-solutions.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class UnifiedSolutionsComponent implements OnChanges {
  @Input() pageData: any;

  highlightedTextUnified = '';
  unifiedSolutionsData: any;

  ngOnChanges(): void {
    const data = this.pageData?.contentPanel?.[0]?.fields;
    if (!data) {
      this.unifiedSolutionsData = null;
      this.highlightedTextUnified = '';
      return;
    }

    this.unifiedSolutionsData = {
      header: data?.title || '',
      cards: data?.component1 || [],
      description: data?.content || null,
    };
    this.highlightedTextUnified = this.unifiedSolutionsData.header.replaceAll(
      'Unified solutions',
      '<span class="pink-800">Unified solutions</span>'
    );
  }
}
